import { render, staticRenderFns } from "./CustomCardLayette.vue?vue&type=template&id=d7c84eb0"
import script from "./CustomCardLayette.vue?vue&type=script&lang=js"
export * from "./CustomCardLayette.vue?vue&type=script&lang=js"
import style0 from "./CustomCardLayette.vue?vue&type=style&index=0&id=d7c84eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports